import styled from 'styled-components'
import { TextSymbolProps } from './types'

export const StyledContainer = styled.div`
  padding: 20px 20px 10px;
`

export const StyledTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #b9bed3;
`

export const StyledCommonBase = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -12px;
`

export const StyledCommonBaseToken = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  margin-top: 10px;
  border-radius: 8px;
  padding: 5px 12px;
  cursor: pointer;

  &:hover {
    background: #f5f7fb;
  }
`

export const TextSymbol = styled.span<TextSymbolProps>`
  font-weight: normal;
  font-size: ${({ fontSize }) => fontSize + 'px' || '12px'};
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #191c1e;
  margin: 0;
  margin-left: 8px;
`
